import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex flex-wrap flex-stack gap-3 mb-8" }
const _hoisted_2 = { class: "d-flex align-items-end flex-wrap gap-2 w-100 w-lg-auto" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus fs-1 text-white" }, null, -1)
const _hoisted_4 = {
  key: 0,
  class: "row row-cols-1 row-cols-md-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_CardEvent = _resolveComponent("CardEvent")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_add_edit_event = _resolveComponent("add-edit-event")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_input, {
        modelValue: _ctx.searchText,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchText) = $event)),
        class: "w-250px mt-2",
        placeholder: _ctx.t('search'),
        "prefix-icon": _ctx.Search,
        clearable: ""
      }, null, 8, ["modelValue", "placeholder", "prefix-icon"]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_radio_group, {
          modelValue: _ctx.filter.type,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filter.type) = $event)),
          class: "me-4",
          onChange: _ctx.getEventos
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_button, { label: "" }, {
              default: _withCtx(() => [
                _createTextVNode("Todos")
              ]),
              _: 1
            }),
            _createVNode(_component_el_radio_button, { label: "NAC" }, {
              default: _withCtx(() => [
                _createTextVNode("Nacional")
              ]),
              _: 1
            }),
            _createVNode(_component_el_radio_button, { label: "INT" }, {
              default: _withCtx(() => [
                _createTextVNode("Internacional")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue", "onChange"]),
        _createVNode(_component_el_button, {
          type: "success",
          onClick: _ctx.openModal,
          class: "w-100 w-md-auto w-lg-auto"
        }, {
          default: _withCtx(() => [
            _hoisted_3,
            _createTextVNode(_toDisplayString(_ctx.t('register')), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    (_ctx.listEvents.length > 0)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredEvents, (evento, index) => {
            return (_openBlock(), _createBlock(_component_CardEvent, {
              key: index,
              to: `/${_ctx.company?.alias.toLowerCase()}/events/${evento.idevent}/manager/home`,
              evento: evento,
              "on-delete": true,
              "on-Edit": true,
              onOnResponse: _ctx.onResponse,
              onOnEditAction: _ctx.onEditAction,
              onOnDeleteAction: _ctx.onDeleteAction
            }, null, 8, ["to", "evento", "onOnResponse", "onOnEditAction", "onOnDeleteAction"]))
          }), 128))
        ])), [
          [_directive_loading, _ctx.loader]
        ])
      : _withDirectives((_openBlock(), _createBlock(_component_el_empty, {
          key: 1,
          description: _ctx.t('notFoundResult')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _ctx.getEventos
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('tryAgain')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["description"])), [
          [_directive_loading, _ctx.loader]
        ]),
    _createVNode(_component_add_edit_event, {
      ref: "AddEditEventRef",
      setting: _ctx.setting,
      onOnResponse: _ctx.onResponse,
      "item-event": _ctx.rowItem,
      "list-seats": _ctx.listSeats
    }, null, 8, ["setting", "onOnResponse", "item-event", "list-seats"])
  ], 64))
}